import type { QTableColumn } from 'quasar';
import { formatDate } from 'src/utils/formatDate';
import { getMailTypeLabel, MailType } from './enum/MailType';
export type MailTemplateGetAttributes = {
  id: string;
  name: string;
  title: string;
  body: string;
  mail_type: MailType;
  created_at: string;
  updated_at: string;
};
export type MailTemplateCreateAttributes = {
  name: string;
  title: string;
  body: string;
  mail_type: MailType;
};
export type MailTemplateUpdateAttributes = {
  name: string;
  title: string;
  body: string;
};
export class MailTemplateModel {
  id: string;
  name: string;
  title: string;
  body: string;
  mail_type: MailType;
  created_at: string;
  updated_at: string;

  constructor(input?: MailTemplateGetAttributes) {
    this.id = input ? input.id : '';
    this.name = input ? input.name : '';
    this.title = input ? input.title : '回答依頼があります';
    this.body = input
      ? input.body
      : '以下のURLからアンケートに回答してください';
    this.mail_type = input ? input.mail_type : 'answer_request';
    this.created_at = input ? formatDate(input.created_at) : '';
    this.updated_at = input ? formatDate(input.updated_at) : '';
  }

  getId(): string {
    return this.id;
  }
  getCreateAttributes(): MailTemplateCreateAttributes {
    return {
      name: this.name,
      title: this.title,
      body: this.body,
      mail_type: this.mail_type,
    };
  }
  getUpdateAttributes(): MailTemplateUpdateAttributes {
    return {
      name: this.name,
      title: this.title,
      body: this.body,
    };
  }
}
export type MailTemplateCollection = MailTemplateModel[];

export const MailTemplateTableColumns: QTableColumn[] = [
  {
    name: 'id',
    label: 'ID',
    align: 'left',
    field: 'id',
    sortable: true,
  },
  {
    name: 'name',
    label: 'メールテンプレート名',
    align: 'left',
    field: 'name',
    sortable: true,
  },
  {
    name: 'mail_type',
    label: '種別',
    align: 'left',
    field: 'mail_type',
    sortable: true,
    format: getMailTypeLabel,
  },
  {
    name: 'title',
    label: 'タイトル',
    align: 'left',
    field: 'title',
    sortable: true,
  },
  {
    name: 'body',
    label: '本文',
    align: 'left',
    field: 'body',
    sortable: true,
  },
];
